import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { verifyPhone, clearError } from '@/store/slices/authSlice'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { Alert, AlertDescription } from '@/components/ui/alert'

const VerifyPhoneForm = () => {
  const [code, setCode] = useState('')
  const dispatch = useDispatch()
  const { loading, error, user } = useSelector(state => state.auth)

  const handleSubmit = (e) => {
    e.preventDefault()
    dispatch(clearError())
    dispatch(verifyPhone(code))
  }

  return (
    <div className="space-y-4">
      <div className="text-center">
        <h2 className="text-2xl font-bold">Verify Your Phone</h2>
        <p className="text-muted-foreground">
          We've sent a verification code to {user?.phone}
        </p>
      </div>

      {error && (
        <Alert variant="destructive">
          <AlertDescription>{error}</AlertDescription>
        </Alert>
      )}

      <form onSubmit={handleSubmit} className="space-y-4">
        <div className="space-y-2">
          <Label htmlFor="code">Verification Code</Label>
          <Input
            id="code"
            type="text"
            placeholder="Enter 6-digit code"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            required
            maxLength={6}
          />
        </div>
        <Button type="submit" className="w-full" disabled={loading}>
          {loading ? 'Verifying...' : 'Verify Phone'}
        </Button>
      </form>
    </div>
  )
}

export default VerifyPhoneForm